<div class="workshop-jobcard-modal-container" [class.jobcard-locked]="isLocked">

    <app-workshop-jobcard-header #header [activeModal]="activeModal" [originalJobcard]="originalJobcard"
        [jobcard]="jobcard" [jobCards]="jobCards" (formReset)="formReset($event)" 
        (jobcardChange)="onJobCardChange($event)" [preServiceChecklist]="preServiceChecklist"
        [originalPreServiceChecklist]="originalPreServiceChecklist"></app-workshop-jobcard-header>


    <ng-template #scheduleServiceContainer>

        <div *ngIf="jobcard.id === 0 || jobcard.id === undefined || jobcard.id === null">
            <div class="send-comms-container" *ngIf="!(jobcard?.customer?.Locked && jobcard?.selectedItem?.locked)">
                <div>{{'bikeshop.modal.shedule_service.send_communication' | translate}}</div>
                <hub-checkbox [(ngModel)]="sendCommunication"></hub-checkbox>
            </div>

            <div class="button-container">
                <hub-button [text]="'bikeshop.modal.shedule_service.button.schedule_and_add_another' | translate"
                    [size]="'xl'" *ngIf="!isPhoneView && !busySchedulingService" [style]="'outline'"
                    [disabled]="!isJobCardValid() || busySchedulingService || jobcard.id > 0 || (jobcard?.customer?.Locked && jobcard?.selectedItem?.locked)"
                    [loading]="busySchedulingService" (buttonClick)="scheduleService(true)"></hub-button>

                <hub-button [text]="'bikeshop.modal.shedule_service.button.schedule_and_open' | translate"
                    [size]="'xl'" *ngIf="!isPhoneView && !rentalBooking && !busySchedulingService" [style]="'outline'"
                    [disabled]="!isJobCardValid() || busySchedulingService || jobcard.id > 0 || (jobcard?.customer?.Locked && jobcard?.selectedItem?.locked)"
                    [loading]="busySchedulingService" (buttonClick)="scheduleService(false, true)"></hub-button>

                <hub-button [text]="'bikeshop.modal.shedule_service.button.schedule' | translate" [size]="'xl'"
                    [style]="'secondary'" [disabled]="!isJobCardValid() || busySchedulingService || jobcard.id > 0"
                    [loading]="busySchedulingService" (buttonClick)="scheduleService(false)"></hub-button>

            </div>
        </div>

    </ng-template>

    <div #workshopJobCardContainer class="workshop-jobcard-container">
        <div class="jobcard-list-container" *ngIf="jobCards && jobCards.length > 0">
            <div>
                <div *ngFor="let jc of jobCards" [ngClass]="{'selected' : jc.id === jobcard.id}"
                    (click)="selectJobCard(jc.id)">
                    <div>#{{jc.jobCardNo}} <span class="active">{{'bikeshop.quicklaunch.active' | translate}}</span>
                    </div>
                </div>
                <div [ngClass]="{'selected' : jobcard.id === 0 || jobcard.id === undefined }"
                    (click)="selectJobCard(0)">
                    <div>{{'bikeshop.rentals.products.draft' | translate}} <span class="new">{{ 'general.new' |
                            translate }}</span></div>
                </div>
            </div>
            <div class="group-container">
                <div>{{ 'bikeshop.modal.shedule_service.group_active_jobs' | translate }} <span><p-inputSwitch
                            [(ngModel)]="groupBookings" [disabled]="!canGroupBookings() || groupBookings"
                            (onChange)="onChangeGroupBookings($event)" /></span></div>
                <div class="group-info"><daz-icon
                        pTooltip="{{ 'bikeshop.modal.shedule_service.group_all_active_jobs_tooltip' | translate}}"
                        name="circle-information" color="#060931" size="24px"></daz-icon> </div>
            </div>
        </div>

        <div *ngIf="jobcard.id" style="display: flex; align-items: flex-start;margin-top: 16px; gap: 16px;">
            <div #linkedItemsContainer
                *ngIf="linkedServices?.length > 1 || (linkableServices?.length > 0 && !isPhoneView)"
                class="jobcard-list-container">
                <div #linkedServicesItems>

                    <hub-button *ngIf="linkedServices?.length > 1" (buttonClick)="showAllLinkedJobs()"
                        [style]="'borderless'" [size]="'sm'"
                        text="{{ 'bikeshop.modal.update_job_card.job_card.all_jobs' | translate }}">
                    </hub-button>
                    <div *ngFor="let jc of visibleLinkedServices" [ngClass]="{'selected' : jc.id === jobcard.id}"
                        (click)="selectJobCard(jc.id)" class="linked-service-item">
                        <div>#{{jc.jobCardID}}
                            <!-- <span class="active" *ngIf="jc.statusID < 40">{{'bikeshop.quicklaunch.active' | translate}}</span>
                        <span class="closed" *ngIf="jc.statusID >= 40 && jc.statusID !== 100">{{'general.closed' | translate}}</span> -->
                            <span class="active" *ngIf="jc.statusID < 40">{{jc.manufacturer}} {{jc.model}}</span>
                            <span class="closed" *ngIf="jc.statusID >= 40 && jc.statusID !== 100">{{jc.manufacturer}}
                                {{jc.model}}</span>
                        </div>
                    </div>
                    <!-- Overflow button -->
                    <div *ngIf="overflowLinkedServices.length > 0" class="linked-services-overflow-button"
                        (click)="showLinkedOverflow = !showLinkedOverflow">
                        <div>+{{ overflowLinkedServices.length }}</div>
                        <div class="overflow-badge">
                            <daz-icon *ngIf="!showLinkedOverflow" [size]="'20px'" [name]="'chevron-down'"
                                [color]="'#060931'"></daz-icon>
                            <daz-icon *ngIf="showLinkedOverflow" [size]="'20px'" [name]="'chevron-up'"
                                [color]="'#060931'"></daz-icon>
                        </div>
                        <div class="overflow-dropdown" *ngIf="showLinkedOverflow" (click)="$event.stopPropagation()">
                            <div class="overflow-item-container">
                                <div *ngFor="let jc of overflowLinkedServices"
                                    [ngClass]="{'selected' : jc.id === jobcard.id}"
                                    (click)="showLinkedOverflow = false;selectJobCard(jc.id);"
                                    class="overflow-job-item">
                                    <div class="job-number">#{{jc.jobCardID}}</div>
                                    <div class="job-details">
                                        <span class="active" *ngIf="jc.statusID < 40">{{jc.manufacturer}}
                                            {{jc.model}}</span>
                                        <span class="closed"
                                            *ngIf="jc.statusID >= 40 && jc.statusID !== 100">{{jc.manufacturer}}
                                            {{jc.model}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hub-button #linkAnotherJobButton
                        *ngIf="!isPhoneView && ((linkableServices && linkableServices.length > 0) || linkedServices?.length > 1)"
                        [disabled]="hasExternalLinkedService || sendingToPOS"
                        (buttonClick)="linkAnotherJob()" [icon]="'plus-alt'" [style]="'borderless'" [size]="'sm'"
                        text="{{ 'bikeshop.modal.update_job_card.job_card.link_another_job' | translate }}">
                    </hub-button>
                </div>
            </div>
        </div>

        <div *ngIf="loadingJobcard && !showLinkedServices">
            <app-workshop-jobcard-skeleton-loader></app-workshop-jobcard-skeleton-loader>
        </div>

        <div class="workshop-content-layout" *ngIf="!loadingJobcard && !showLinkedServices">
            <!-- Left Side - Accordion Sections -->
            <div class="workshop-left-panel"
                *ngIf="jobcard.id === 0 || jobcard.id === undefined || jobcard.id === null">
              <app-workshop-jobcard-accordion #workshopJobcardAccordion [jobcard]="jobcard"
                  [preServiceChecklist]="preServiceChecklist" [serviceTypes]="serviceTypes"
                  [thirdParties]="thirdParties" [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"
                  [technicians]="technicians" [isPhoneView]="isPhoneView" [systemUsers]="systemUsers"
                  [groupBookings]="groupBookings" [jobCards]="jobCards"
                  [collectionsConfigured]="collectionsConfigured"
                  [linkedTags]="linkedTags" (linkedTagsOutput)="setTags($event)"
                  (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-accordion>

                <div *ngIf="isPhoneView">
                    <ng-container *ngTemplateOutlet="scheduleServiceContainer;"></ng-container>
                </div>
            </div>
            <div class="workshop-left-panel" *ngIf="jobcard.id > 0">
                <app-workshop-jobcard-accordion-manage #workshopJobcardAccordionManage [jobcard]="jobcard"
                    [preServiceChecklist]="preServiceChecklist" [serviceTypes]="serviceTypes"
                    [productSKUServiceTypeCollection]="productSKUServiceTypeCollection" [technicians]="technicians"
                    [systemUsers]="systemUsers" [groupBookings]="groupBookings" [jobCards]="jobCards"
                    [collectionsConfigured]="collectionsConfigured" [isPhoneView]="isPhoneView"
                    [goToMessaging]="goToMessaging" [cancelDisabled]="isPrimaryCustomersLastJobCard"
                    (jobcardChange)="onJobCardChange($event)"></app-workshop-jobcard-accordion-manage>
            </div>

            <!-- Right Side - Getting Started / Empty State -->
            <div class="workshop-right-panel" *ngIf="!isPhoneView">
                <div style="width: 100%;">
                    <app-workshop-jobcard-quote [jobcard]="jobcard" [serviceTypes]="serviceTypes"
                        [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"
                        (jobcardChange)="onJobCardChange($event)" (ownerChanged)="reloadJobcard($event)"
                        (sendingToPOSChange)="sendingToPOS = $event"></app-workshop-jobcard-quote>

                    <ng-container *ngTemplateOutlet="scheduleServiceContainer;"></ng-container>

                </div>

            </div>
        </div>

        <div *ngIf="showLinkedServices">
            <app-workshop-jobcard-linked-services [jobCardID]="jobCardID" [linkedServices]="linkedServices"
                [linkableServices]="linkableServices" (jobSelected)="selectJobCard($event)"
                (favouriteCustomerChanged)="onFavouriteCustomerChanged($event)"
                (linkedServicesUpdated)="getLinkedjobCards()"></app-workshop-jobcard-linked-services>
        </div>
    </div>

</div>

<p-toast position="bottom-center" styleClass="hubtiger-jobcard-toast"></p-toast>
